import { getDatabase, onValue, ref, update } from 'firebase/database'
import Swal from 'sweetalert2'
import { getWorkers } from '../services/workers'
import {
  createPaletNomina,
  createProductionNomina,
  getNominas,
} from '../services/nomina'
import {
  getArea,
  getPuestoByFirstName,
  getPuestoById,
  getRetencionesById,
  getWorkerById,
} from './workersFunctions'
import { database } from '../configs/firebase'
import { isWithinDateRange } from './deliveriesFunctions'
import { processNombre } from '../components/Deliveries/worker'
import { generateMonthlyReport } from '../services/reports'

const getNominaById = (id) => {
  const nominas = getNominas()

  const nominaData = nominas.find((item) => item.id === id)

  return nominaData
}

export const checkWorkerArea = (idWorker, idNomina) => {
  const nomina = getNominaById(idNomina)

  const areaWorker = getArea(idWorker)

  if (areaWorker !== 'No encontrado') {
    let nodesToCheck = []
    if (areaWorker === '2') {
      nodesToCheck = [nomina[1]]
    } else if (areaWorker === '3' || areaWorker === '4') {
      nodesToCheck = [nomina[1], nomina[2]]
    } else {
      console.log(
        `No se requiere evaluación para el área del trabajador: ${areaWorker}`
      )
      return 0
    }

    // Días de la semana en orden correcto
    const daysOfWeek = [
      'lunes',
      'martes',
      'miercoles',
      'jueves',
      'viernes',
      'sabado',
      'domingo',
    ]

    // Ordenar los objetos dentro de `nodesToCheck`
    const sortedNodesToCheck = nodesToCheck.map((node) => {
      // Convertimos el objeto con días en un array de entradas
      const sortedDays = Object.entries(node).sort(([dayA], [dayB]) => {
        // Ordenamos según la posición en `daysOfWeek`
        return daysOfWeek.indexOf(dayA) - daysOfWeek.indexOf(dayB)
      })

      // Convertimos las entradas ordenadas de vuelta a un objeto
      return Object.fromEntries(sortedDays)
    })

    let salarios = []

    for (const [dayKey, dayNode] of Object.entries(sortedNodesToCheck)) {
      // Aseguramos que `dayNode` tiene nodos internos
      if (!dayNode || typeof dayNode !== 'object') continue

      // Recorremos cada sub-nodo (por ejemplo, lunes, martes) dentro de `dayNode`
      for (const [subDayKey, subDayNode] of Object.entries(dayNode)) {
        const trabajadoresNode = subDayNode?.trabajadores

        // Verificamos si `trabajadoresNode` existe y es un objeto
        if (!trabajadoresNode || typeof trabajadoresNode !== 'object') {
          console
            .log
            //`Trabajadores no encontrados o estructura inválida en el día: ${subDayKey}`
            ()
          continue
        }

        // Iteramos sobre los trabajadores dentro del día actual
        for (const [trabajadorKey, trabajadorData] of Object.entries(
          trabajadoresNode
        )) {
          // Verificamos si el trabajador tiene el ID que buscamos
          if (
            trabajadorData &&
            typeof trabajadorData === 'object' &&
            trabajadorData.id === idWorker
          ) {
            //console.log('Trabajador encontrado:', trabajadorData)
            salarios.push({
              key: subDayKey,
              salary: trabajadorData.salarioGenerado * 1,
            })
          }
        }
      }
    }
    return salarios
  } else {
    return 'No encontrado'
  }
}

export const getStatusToString = (status) => {
  switch (status) {
    case '1':
      return 'ABIERTA'
    case '2':
      return 'CERRADA'
    case '3':
      return 'CANCELADA'
    default:
      return 'error'
  }
}

export const cancelNomina = (id) => {
  Swal.fire({
    icon: 'question',
    title: '¿Estas seguro de cancelar esta nómina',
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: 'Sí, estoy seguro',
    denyButtonText: 'Cancelar',
    confirmButtonColor: '#28A745',
    customClass: {
      container: 'my-swal',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const db = getDatabase()

      update(ref(db, `nominas/${id}/`), {
        status: '3',
      })
      Swal.fire({
        title: 'Hecho',
        icon: 'success',
        text: 'Nómina cancelada exitosamente',
        position: 'top-end',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 1000,
        customClass: {
          container: 'my-swal',
        },
      })
    } else if (result.isDenied) {
      Swal.fire({
        title: 'Operación abortada',
        icon: 'info',
        position: 'top-end',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 1000,
        customClass: {
          container: 'my-swal',
        },
      })
    }
  })
}

export const closeNomina = (id) => {
  Swal.fire({
    icon: 'question',
    title: '¿Estas seguro de cerrar esta nómina',
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: 'Sí, estoy seguro',
    denyButtonText: 'Cerrar',
    confirmButtonColor: '#28A745',
    customClass: {
      container: 'my-swal',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const db = getDatabase()

      update(ref(db, `nominas/${id}/`), {
        status: '2',
      })
      Swal.fire({
        title: 'Hecho',
        icon: 'success',
        text: 'Nómina cerrada exitosamente',
        position: 'top-end',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 1000,
        customClass: {
          container: 'my-swal',
        },
      })
    } else if (result.isDenied) {
      Swal.fire({
        title: 'Operación abortada',
        icon: 'info',
        position: 'top-end',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 1000,
        customClass: {
          container: 'my-swal',
        },
      })
    }
  })
}

export const openNomina = (id) => {
  Swal.fire({
    icon: 'question',
    title: '¿Estas seguro de abrir esta nómina',
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: 'Sí, estoy seguro',
    denyButtonText: 'Cerrar',
    confirmButtonColor: '#28A745',
    customClass: {
      container: 'my-swal',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const db = getDatabase()

      update(ref(db, `nominas/${id}/`), {
        status: '1',
      })
      Swal.fire({
        title: 'Hecho',
        icon: 'success',
        text: 'Nómina abierta exitosamente',
        position: 'top-end',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 1000,
        customClass: {
          container: 'my-swal',
        },
      })
    } else if (result.isDenied) {
      Swal.fire({
        title: 'Operación abortada',
        icon: 'info',
        position: 'top-end',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 1000,
        customClass: {
          container: 'my-swal',
        },
      })
    }
  })
}

export const checkStatus = (status) => {
  if (status === '2' || status === '3') {
    return true
  } else {
    return false
  }
}

export const getStatus = (id) => {
  const nomina = getNominaById(id)

  return nomina?.status || null
}

export const calculateProductionSalaries = (dayObject, productData) => {
  if (!dayObject || !productData) return dayObject

  // Obtenemos todos los trabajadores de la base de datos o fuente de datos
  const workers = getWorkers()

  dayObject.trabajadores
    .filter((workerInDay) => workerInDay !== null) // Filtramos trabajadores no nulos
    .forEach((workerInDay) => {
      // Encontramos al trabajador en la lista general que coincida con el ID
      const workerData = workers.find((worker) => worker.id === workerInDay.id)

      if (workerData) {
        // Extraemos el campo `variables` del trabajador encontrado
        const { variables } = workerData

        // Buscamos en `variables` el registro que coincida con el `producto` de `dayObject`
        const matchingVariable = variables.find(
          (variable) => variable.variable === dayObject.producto
        )

        // Buscar la variable que contiene las palabras 'salario' o 'sueldo'
        const salarioWorker = variables.find(
          (variable) =>
            variable.variable.toLowerCase().includes('salario') ||
            variable.variable.toLowerCase().includes('sueldo')
        )

        //Asignamos el sueldo diario para guardarlo
        workerInDay.sueldoDiario = salarioWorker.importe

        if (dayObject.salarioPDia === '1') {
          if (matchingVariable) {
            //Asignamos los campos a guardar de comision
            workerInDay.comision = matchingVariable.importe

            // Aquí es donde podemos continuar con la lógica de cálculo del salario
            //En caso de que el trabajador pertenezca al area de producción
            let salarioCalculado = matchingVariable.importe * dayObject.cantidad

            //Se calcula el salario + las horas trabajadas x día
            if (dayObject.horaSalarioPDia > 0) {
              salarioCalculado =
                salarioCalculado +
                parseFloat(dayObject.horaSalarioPDia) *
                (salarioWorker.importe / 10)
            }

            if (salarioCalculado < salarioWorker.importe) {
              salarioCalculado = salarioWorker.importe
            }
            // Asignamos el salario calculado al campo `salarioGenerado` de `workerInDay`
            workerInDay.salarioGenerado = salarioCalculado.toFixed(2)
          } else {
            console.log(
              `Producto ${dayObject.producto} no encontrado para el trabajador ${workerData.id}`
            )
            workerInDay.salarioGenerado = salarioWorker.importe
          }
        } else {
          workerInDay.salarioGenerado = salarioWorker.importe.toFixed(2)
        }
      }
    })
  return dayObject
}

export const calculatePaletSalaries = (dayObject, productData, id) => {
  if (!dayObject || !productData) return dayObject

  // Obtenemos todos los trabajadores de la base de datos o fuente de datos
  const workers = getWorkers()

  Object.values(dayObject.trabajadores)
    .filter((workerInDay) => workerInDay !== null)
    .forEach((workerInDay) => {
      // Encontramos al trabajador en la lista general que coincida con el ID
      const workerData = workers.find((worker) => worker.id === workerInDay.id)

      if (workerData) {
        // Extraemos el campo `variables` del trabajador encontrado
        const { variables } = workerData

        let salarioCalculado = 0

        // Buscamos en `variables` el registro que coincida con el `producto` de `dayObject`
        const matchingVariable = variables.find(
          (variable) => variable.variable === dayObject.producto1
        )

        let matchingVariable2 = ''

        if (dayObject.producto2) {
          matchingVariable2 = variables.find(
            (variable) => variable.variable === dayObject.producto2
          )
        }

        // Buscar la variable que contiene las palabras 'salario' o 'sueldo'
        const salarioWorker = variables.find(
          (variable) =>
            variable.variable.toLowerCase().includes('salario') ||
            variable.variable.toLowerCase().includes('sueldo')
        )

        // Buscar la variable que contiene la palabra 'brocales'
        const brocalesVariable = variables.find(
          (variable) =>
            variable.variable.toLowerCase().includes('brocales') ||
            variable.variable.toLowerCase().includes('brocal')
        )

        if (brocalesVariable) {
          workerInDay.brocales = brocalesVariable.importe
          //Se calcula el salario de producción de brocales
          salarioCalculado += brocalesVariable.importe * dayObject.brocales
        }
        console.log(salarioCalculado)
        //Asignamos el sueldo diario para guardarlo
        workerInDay.sueldoDiario = salarioWorker.importe

        if (dayObject.salarioPDia === '1') {
          if (matchingVariable && brocalesVariable) {
            //Asignamos los campos a guardar de comision
            workerInDay.comision = matchingVariable.importe
            //console.log(workerInDay.comision)
            // Aquí es donde podemos continuar con la lógica de cálculo del salario

            //Se calcula el salario de paletizado
            salarioCalculado += matchingVariable.importe * dayObject.cantidad1

            if (matchingVariable2) {
              //Asignamos los campos a guardar de comision
              workerInDay.comision2 = matchingVariable2.importe

              //Se calcula el salario de paletizado
              salarioCalculado +=
                matchingVariable2.importe * dayObject.cantidad2
            }

            //Se calcula el salario + las horas trabajadas x día
            if (dayObject.horaSalarioPDia > 0) {
              salarioCalculado +=
                parseFloat(dayObject.horaSalarioPDia) *
                (salarioWorker.importe / 10)
            }

            // Asignamos el salario calculado al campo `salarioGenerado` de `workerInDay`
            workerInDay.salarioGenerado = salarioCalculado.toFixed(2)
          } else {
            /* console.log(
              `Producto ${dayObject.producto} no encontrado para el trabajador ${workerData.id}`
            ) */
          }
        } else {
          //Si el el salario x dia es sí
          salarioCalculado += salarioWorker.importe
          workerInDay.salarioGenerado = salarioCalculado.toFixed(2)
        }
      }
    })
  return dayObject
}

export const calculateLogisticSalaries = (object, id) => {
  const worker = getWorkerById(object.trabajador.id)
  const wPuesto = getPuestoById(object.trabajador.id)

  let salario = 0

  const pzsVariable = worker.variables?.find(
    (variable) =>
      variable.variable.toLowerCase().includes('pieza') ||
      variable.variable.toLowerCase().includes('piezas')
  )
  const salarioVariable = worker.variables?.find(
    (variable) =>
      variable.variable.toLowerCase().includes('sueldo') ||
      variable.variable.toLowerCase().includes('salario')
  )
  const retenciones = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('retenciones')
  )

  const palets = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('palets')
  )

  const brocales = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('brocales')
  )

  if (object.extras?.palets?.respuesta === '1' && palets) {
    const importePalets = palets.importe || 0
    salario += object.extras.palets.cantidad * importePalets
    object.importes.palets = importePalets
  }

  if (object.extras?.brocales?.respuesta === '1' && brocales) {
    const importeBrocales = brocales.importe || 0
    salario += object.extras.brocales.cantidad * importeBrocales
    object.importes.brocales = importeBrocales
  }

  if (pzsVariable) {
    const importePzs = pzsVariable.importe || 0
    salario += object.pzsCargadas * importePzs
    object.importes.pzaCargada = importePzs
  } else {
    console.warn("No se encontró una variable de 'pieza' en worker.variables.")
  }

  if (salarioVariable) {
    const importeSalario = salarioVariable.importe || 0

    salario +=
      object.diasLaborados * importeSalario +
      object.horasExtra * (importeSalario / 10)
    object.importes.sueldoDiario = importeSalario
  } else {
    console.warn(
      "No se encontró una variable de 'salario/sueldo' en worker.variables."
    )
  }
  // Sumar importes de los bonos solo si existen
  if (Array.isArray(object.bonos) && object.bonos.length > 0) {
    let bonos = []
    object.bonos.forEach((bono) => {
      // Buscar la variable que coincide con el bono actual
      const bonoVariable = worker.variables?.find(
        (variable) => variable.variable.toLowerCase() === bono.toLowerCase()
      )

      bonos.push(bonoVariable)

      // Si existe el bono en worker.variables, sumamos su importe; si no, sumamos 0
      salario += bonoVariable ? bonoVariable.importe : 0
    })
    object.importes.bonos = bonos
  }

  if (object && wPuesto === '8') {
    // Buscar el valor de `importe` de la variable que contiene "kenworth" en su nombre
    const kenworth18Variable = worker.variables?.find((variable) =>
      variable.variable.toLowerCase().includes('kenworth 18')
    )
    const kenworth10Variable = worker.variables?.find((variable) =>
      variable.variable.toLowerCase().includes('kenworth 10')
    )
    const camionVariable = worker.variables?.find((variable) =>
      variable.variable.toLowerCase().includes('camion')
    )
    const dobleVariable = worker.variables?.find((variable) =>
      variable.variable.toLowerCase().includes('doble')
    )
    const nissanVariable = worker.variables?.find((variable) =>
      variable.variable.toLowerCase().includes('nissan')
    )

    if (kenworth18Variable) {
      const importeKenworth18 = kenworth18Variable.importe || 0
      salario += object.viajes.kenworth * importeKenworth18
      object.importes.kenworth18 = importeKenworth18
    } else {
      console.warn(
        "No se encontró una variable de 'kenworth 10' en worker.variables."
      )
    }
    if (kenworth10Variable) {
      const importeKenworth10 = kenworth10Variable.importe || 0
      salario += object.viajes.kenworth10 * importeKenworth10
      object.importes.kenworth10 = kenworth10Variable.importe
    }
    if (camionVariable || kenworth10Variable) {
      const importeCamion = camionVariable.importe || 0
      salario += object.viajes.camion * importeCamion
      object.importes.camion = camionVariable.importe
    } else {
      console.warn(
        "No se encontró una variable de 'camion' en worker.variables."
      )
    }
    if (dobleVariable) {
      const importeDoble = dobleVariable.importe || 0
      salario += object.viajes.doble * importeDoble
      object.importes.doble = importeDoble
    } else {
      console.warn(
        "No se encontró una variable de 'doble' en worker.variables."
      )
    }
    if (nissanVariable) {
      const importeNissan = nissanVariable.importe || 0
      salario += object.viajes.nissan * importeNissan
      object.importes.nissan = importeNissan
    } else {
      console.warn(
        "No se encontró una variable de 'nissan' en worker.variables."
      )
    }
  } else {
    console.log('error')
  }
  object.salarioSemanal = salario

  if (retenciones) {
    const importeRetencion = retenciones.importe || 0
    object.salarioNeto = salario + importeRetencion
    object.importes.retencion = importeRetencion
  } else {
    console.warn(
      "No se encontró una variable de 'retención' en worker.variables."
    )
  }

  return object
}

export const calculateSalesSalaries = (object, comissions) => {
  const worker = getWorkerById(object.trabajador.id)

  let salario = 0
  let comision = 0

  const salarioVariable = worker.variables?.find(
    (variable) =>
      variable.variable.toLowerCase().includes('sueldo') ||
      variable.variable.toLowerCase().includes('salario')
  )
  const retenciones = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('retenciones')
  )

  const cpc30rVariable = worker.variables?.find(
    (variable) =>
      (variable.variable.toLowerCase().includes('cpc30r') ||
        variable.variable.toLowerCase().includes('cemento comision 1')) && variable.variable.toLowerCase().includes('1')

  )

  if (cpc30rVariable) {
    comision += comissions.cpc30r * cpc30rVariable.importe
    object.importes.cpc30r = cpc30rVariable.importe
  } else {
    console.warn("No se encontró una variable de 'cpc30r' en worker.variables")
  }

  const cpc30r2Variable = worker.variables?.find(
    (variable) =>
      (variable.variable.toLowerCase().includes('cpc30r') ||
        variable.variable.toLowerCase().includes('cemento')) && variable.variable.toLowerCase().includes('2')

  )

  if (cpc30r2Variable) {
    comision += comissions.cpc30r2 * cpc30r2Variable.importe
    object.importes.cpc30r2 = cpc30r2Variable.importe
  } else {
    console.warn("No se encontró una variable de 'cpc30r' en worker.variables")
  }

  const mortVariable = worker.variables?.find(
    (variable) =>
      variable.variable.toLowerCase().includes('mort') ||
      variable.variable.toLowerCase().includes('mortero')
  )

  if (mortVariable) {
    comision += comissions.mort * mortVariable.importe
    object.importes.mort = mortVariable.importe
  } else {
    console.warn("No se encontró una variable de 'mort' en worker.variables")
  }

  const mort2Variable = worker.variables?.find(
    (variable) =>
      (variable.variable.toLowerCase().includes('mort') ||
        variable.variable.toLowerCase().includes('mortero')) && variable.variable.toLowerCase().includes('2')
  )

  if (mort2Variable) {
    comision += comissions.mort2 * mort2Variable.importe
    object.importes.mort2 = mort2Variable.importe
  } else {
    console.warn("No se encontró una variable de 'mort' en worker.variables")
  }

  const var38Variable = worker.variables?.find(
    (variable) =>
      variable.variable.toLowerCase().includes('var3/8') ||
      variable.variable.toLowerCase().includes('varilla')
  )

  if (var38Variable) {
    comision += comissions.var38 * var38Variable.importe
    object.importes.var38 = var38Variable.importe
  } else {
    console.warn("No se encontró una variable de 'var3/8' en worker.variables")
  }

  const blockVariable = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('block')
  )

  if (blockVariable) {
    comision += comissions.block * blockVariable.importe
    object.importes.block = blockVariable.importe
  } else {
    console.warn("No se encontró una variable de 'block' en worker.variables")
  }

  const tabiconVariable = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('tabicon')
  )

  if (tabiconVariable) {
    comision += comissions.tabicon * tabiconVariable.importe
    object.importes.tabicon = tabiconVariable.importe
  } else {
    console.warn("No se encontró una variable de 'tabicon' en worker.variables")
  }

  const poste2Variable = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('poste 2m')
  )

  if (poste2Variable && comissions.poste2) {
    comision += comissions.poste2 * poste2Variable.importe
    object.importes.poste2 = poste2Variable.importe
  } else {
    console.warn("No se encontró una variable de 'poste 2' en worker.variables")
  }

  const poste25Variable = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('poste 2.5m')
  )

  if (poste25Variable && comissions.poste25) {
    comision += comissions.poste25 * poste25Variable.importe
    object.importes.poste25 = poste25Variable.importe
  } else {
    console.warn(
      "No se encontró una variable de 'poste 2.5' en worker.variables"
    )
  }

  if (salarioVariable) {
    const importeSalario = salarioVariable.importe || 0
    const diasLaborados = Number(object.diasLaborados) || 0
    const horasExtra = Number(object.horasExtra) || 0

    object.importes.sueldoDiario = importeSalario
    salario +=
      diasLaborados * importeSalario + horasExtra * (importeSalario / 10)

    //console.log(diasLaborados, importeSalario, horasExtra, salario)
  }

  // Sumar importes de los bonos solo si existen
  if (Array.isArray(object.bonos) && object.bonos.length > 0) {
    object.bonos.forEach((bono) => {
      // Buscar la variable que coincide con el bono actual
      const bonoVariable = worker.variables?.find(
        (variable) => variable.variable.toLowerCase() === bono.toLowerCase()
      )

      // Si existe el bono en worker.variables, sumamos su importe; si no, sumamos 0
      salario += bonoVariable ? bonoVariable.importe : 0
    })
  }

  object.salarioSemanal = salario + comision
  object.comisiones = comision

  if (retenciones) {
    const importeRetencion = retenciones.importe || 0
    object.importes.retencion = importeRetencion
    object.salarioNeto = salario + comision + importeRetencion
  } else {
    console.warn(
      "No se encontró una variable de 'retención' en worker.variables."
    )
  }

  return object
}

export const calculateAdminSalaries = (object) => {
  const worker = getWorkerById(object.trabajador.id)

  let salario = 0

  const salarioVariable = worker.variables?.find(
    (variable) =>
      variable.variable.toLowerCase().includes('sueldo') ||
      variable.variable.toLowerCase().includes('salario')
  )
  const retenciones = worker.variables?.find((variable) =>
    variable.variable.toLowerCase().includes('retenciones')
  )

  if (salarioVariable) {
    const importeSalario = salarioVariable.importe || 0
    object.importes.sueldoDiario = importeSalario

    salario +=
      object.diasLaborados * importeSalario +
      object.horasExtra * (importeSalario / 10)
  }

  // Sumar importes de los bonos solo si existen
  if (Array.isArray(object.bonos) && object.bonos.length > 0) {
    let bonos = []
    object.bonos.forEach((bono) => {
      // Buscar la variable que coincide con el bono actual
      const bonoVariable = worker.variables?.find(
        (variable) => variable.variable.toLowerCase() === bono.toLowerCase()
      )

      bonos.push(bonoVariable)

      // Si existe el bono en worker.variables, sumamos su importe; si no, sumamos 0
      salario += bonoVariable ? bonoVariable.importe : 0
    })
    object.importes.bonos = bonos
  }

  object.salarioSemanal = salario

  if (retenciones) {
    const importeRetencion = retenciones.importe || 0
    object.importes.retencion = importeRetencion
    object.salarioNeto = salario + importeRetencion
  } else {
    console.warn(
      "No se encontró una variable de 'retención' en worker.variables."
    )
  }

  return object
}

export const getDeliveriesByDriver = (driverObject, id) => {
  const kenworth = []
  const kenworth10 = []
  const camion = []
  const ford2014 = []
  const nissan = []
  const pzsCargadas = []

  const nomina = getNominaById(id)

  const nombreProcesado = processNombre(
    driverObject.trabajador.nombre.toLowerCase()
  )

  onValue(ref(database, 'entregas/'), (snapshot) => {
    snapshot.forEach((item) => {
      if (isWithinDateRange(nomina, item.val())) {
        if (
          item.val().chofer.toLowerCase() === nombreProcesado &&
          getPuestoByFirstName(item.val().chofer.toLowerCase()) === '8'
        ) {
          switch (item.val().unidad) {
            case 'Kenworth':
            case 'Kenworth 18':
              kenworth.push(1)
              break
            case 'Kenworth 10':
              kenworth10.push(1)
              break
            case 'International':
            case 'Camión Ford':
              camion.push(1)
              break
            case 'Camioneta Ford':
              ford2014.push(1)
              break
            case 'Nissan 2014':
              nissan.push(1)
              break
            case 'Recogen (Camioneta)':
            case 'Recogen (Camion)':
            case 'Recogen (Torton)':
              const productos = item.val().producto.split(', ')
              //Filtra los productos que no sean block o tabicon y extrae los numeros
              const numerosFiltrados = productos
                .filter(
                  (item) =>
                    !item.includes('CPC30R') &&
                    !item.includes('MORT') &&
                    !item.includes('VAR3/8') &&
                    !item.includes('CPC-MORT') &&
                    !item.includes('Block Macizo') &&
                    !item.includes('Poste 2x10x10') &&
                    !item.includes('Poste 2.5x10x10') &&
                    !item.includes('Poste 2x15x15') &&
                    !item.includes('Poste 2.5x15x15') &&
                    !item.includes('TC6') &&
                    !item.includes('TC8') &&
                    !item.includes('TC10') &&
                    !item.includes('TC12') &&
                    !item.includes('TC15') &&
                    !item.includes('TC18') &&
                    !item.includes('TC24') &&
                    !item.includes('Brocal')
                )
                .map((item) => parseInt(item))

              // Suma los números en el array resultante
              const sumaTotal = numerosFiltrados.reduce(
                (total, num) => total + num,
                0
              )
              pzsCargadas.push(sumaTotal)
              break
            default:
              break
          }
          driverObject.viajes.kenworth = kenworth.length
          driverObject.viajes.kenworth10 = kenworth10.length
          driverObject.viajes.camion = camion.length
          driverObject.viajes.doble = ford2014.length
          driverObject.viajes.nissan = nissan.length
          driverObject.pzsCargadas = pzsCargadas.reduce(
            (total, num) => total + num,
            0
          )
        } else if (
          (item.val().chofer.toLowerCase() === nombreProcesado ||
            item.val().ayudante.toLowerCase() === nombreProcesado ||
            item.val().ayudante2.toLowerCase() === nombreProcesado) &&
          (item.val().unidad !== 'Nissan 2014' ||
            item.val().unidad.includes('Recogen'))
        ) {
          const productos = item.val().producto.split(', ')

          //Filtra los productos que no sean block o tabicon y extrae los numeros
          const numerosFiltrados = productos
            .filter(
              (item) =>
                !item.includes('CPC30R') &&
                !item.includes('MORT') &&
                !item.includes('VAR3/8') &&
                !item.includes('Poste 2x10x10') &&
                !item.includes('Poste 2.5x10x10') &&
                !item.includes('Poste 2x15x15') &&
                !item.includes('Poste 2.5x15x15') &&
                !item.includes('TC6') &&
                !item.includes('TC8') &&
                !item.includes('TC10') &&
                !item.includes('TC12') &&
                !item.includes('TC15') &&
                !item.includes('TC18') &&
                !item.includes('TC24') &&
                !item.includes('Brocal')
            )
            .map((item) => parseInt(item))

          // Suma los números en el array resultante
          const sumaTotal = numerosFiltrados.reduce(
            (total, num) => total + num,
            0
          )

          pzsCargadas.push(sumaTotal)

          driverObject.pzsCargadas = pzsCargadas.reduce(
            (total, num) => total + num,
            0
          )
        }
      }
    })
  })

  driverObject = calculateLogisticSalaries(driverObject, id)

  return driverObject
}

export const getComisionsLogisticWorker = (id, cantidad, index) => {
  const worker = getWorkerById(id)
  let totalComision = 0

  const variableComision =
    (Array.isArray(worker?.variables) &&
      worker.variables.find((variable) =>
        variable.variable?.toLowerCase().includes(index || '')
      )) ||
    null

  if (variableComision) {
    const importe = variableComision.importe || 0
    totalComision = importe * cantidad
  } else {
    /* console.warn(
      `No se encontró una variable de '${index}' en worker.variables.`
    ) */
  }

  return totalComision
}

export const getMonthlyData = (initialDate, finalDate) => {
  const nominas = getNominas()

  // Convertir las fechas a objetos Date y eliminar la parte del tiempo
  const start = new Date(initialDate)
  start.setHours(0, 0, 0, 0)
  const end = new Date(finalDate)
  end.setHours(0, 0, 0, 0)

  // Filtrar nóminas dentro del rango de fechas
  const filteredNominas = nominas.filter((nomina) => {
    const nominaDate = new Date(nomina.finalDate)
    nominaDate.setHours(0, 0, 0, 0)
    return nominaDate >= start && nominaDate <= end
  })

  generateMonthlyReport(filteredNominas, start, end)
}

export const getWeeklyProductionSalaries = (week, id) => {
  const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado']
  const salarioSemanal = {
    1: {
      salarioNeto: 0,
      salarioBruto: 0,
    },
    2: {
      salarioNeto: 0,
      salarioBruto: 0,
    },
    3: {
      salarioNeto: 0,
      salarioBruto: 0,
    },
    4: {
      salarioNeto: 0,
      salarioBruto: 0,
    },
  } // Inicializa los salarios semanales

  dias.forEach((dia) => {
    if (week[dia] && week[dia].trabajadores) {
      const { trabajadores, salarioPDia, cantidad, horaSalarioPDia } = week[dia]

      Object.keys(trabajadores).forEach((trabajadorId) => {
        const trabajador = trabajadores[trabajadorId]
        const sueldoDiario = parseFloat(trabajador.sueldoDiario) || 0
        const comision = parseFloat(trabajador.comision) || 0
        const cantidadProd = parseFloat(cantidad)
        const retencion = parseFloat(getRetencionesById(trabajador.id))
        const horaPDia = parseFloat(horaSalarioPDia) || 0

        if (trabajadorId !== 0) {
          if (salarioPDia === '0') {
            //Si salarioPDia  es 0, sumamos sueldoDiario al salariosemanal
            salarioSemanal[trabajadorId].salarioBruto += sueldoDiario
          } else {
            // Si salarioPDia es 1, calcular comisiones
            let totalComision = comision * cantidadProd
            if (totalComision < sueldoDiario) {
              totalComision = sueldoDiario
            }
            salarioSemanal[trabajadorId].salarioBruto +=
              horaPDia * (sueldoDiario / 10)
            salarioSemanal[trabajadorId].salarioBruto += totalComision
            salarioSemanal[trabajadorId].salarioNeto = retencion
          }
        }
      })
    }
  })

  week.salarioSemanal = salarioSemanal

  createProductionNomina(week, id)

  return null
}

export const getWeeklyPaletSalaries = (week, id) => {
  const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado']
  const salarioSemanal = {
    5: {
      salarioNeto: 0,
      salarioBruto: 0,
    },
    6: {
      salarioNeto: 0,
      salarioBruto: 0,
    },
    7: {
      salarioNeto: 0,
      salarioBruto: 0,
    },
  } // Inicializa los salarios semanales

  dias.forEach((dia) => {
    if (week[dia] && week[dia].trabajadores) {
      const {
        trabajadores,
        salarioPDia,
        cantidad1,
        cantidad2,
        horaSalarioPDia,
        brocales
      } = week[dia]

      Object.keys(trabajadores).forEach((trabajadorId) => {
        const trabajador = trabajadores[trabajadorId]
        const sueldoDiario = parseFloat(trabajador.sueldoDiario) || 0
        const comision = parseFloat(trabajador.comision) || 0
        const comision2 = parseFloat(trabajador.comision2) || 0
        const cantidadProd = parseFloat(cantidad1)
        const cantidadProd2 = parseFloat(cantidad2)
        const retencion = parseFloat(getRetencionesById(trabajador.id))
        const horaPDia = parseFloat(horaSalarioPDia) || 0
        const comisionBrocales = parseFloat(trabajador.brocales) || 0
        const brocalesPDia = parseFloat(brocales) || 0

        if (trabajadorId !== 0) {
          if (salarioPDia === '0') {
            //Si el salarioPDia es 0, sumamos sueldo diario al salario semanal
            salarioSemanal[trabajadorId].salarioBruto += sueldoDiario + (brocalesPDia * comisionBrocales)
          } else {
            // Si salarioPDia es 1, calcular comisiones
            let totalComision = 0
            totalComision += comision * cantidadProd

            if (comision2) {
              totalComision += comision2 * cantidadProd2
            }

            salarioSemanal[trabajadorId].salarioBruto +=
              horaPDia * (sueldoDiario / 10)
            salarioSemanal[trabajadorId].salarioBruto += brocalesPDia * comisionBrocales
            salarioSemanal[trabajadorId].salarioBruto += totalComision
            salarioSemanal[trabajadorId].salarioNeto = retencion
          }
        }
      })
    }
  })

  week.salarioSemanal = salarioSemanal

  createPaletNomina(week, id)

  return null
}
